const linkButtons = document.querySelectorAll('[js-link-button]');
linkButtons.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const linkContents = document.querySelectorAll('[js-child-content]');
    const title = link.getAttribute('data-value');

    if (link.classList.contains('active')) {
      link.classList.remove('active');
      
      linkContents.forEach(content => {
        content.classList.add('hidden');
      });
    } else {
      link.classList.add('active');

      linkContents.forEach(content => {
        const content_title = content.getAttribute('data-value');
  
        if (title == content_title) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    }
  });
});

const childLinkButtons = document.querySelectorAll('[js-child-link-button]');

childLinkButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const title = button.getAttribute('data-value');

    if (button.classList.contains('active')) {
      button.classList.remove('active');
      const childLinkContents = document.querySelectorAll('[js-grand-child-content]');
      childLinkContents.forEach(content => {
        content.classList.add('hidden');
      });
    } else {
      button.classList.add('active');

      const childLinkContents = document.querySelectorAll('[js-grand-child-content]');
      childLinkContents.forEach(content => {
        const content_title = content.getAttribute('data-value');

        if (title == content_title) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      }); 
    }
  });
});

const closeSearchBtn = document.querySelector('[js-search-close-button]');
if (closeSearchBtn) {
  closeSearchBtn.addEventListener('click', (e) => {
    e.preventDefault();

    const input = closeSearchBtn.parentNode.querySelector('.search-form__input');
    if (input) input.value = '';

    window.location.href = window.location.href.split('?')[0]; 
  });
}